export enum LocalStorage {
  LANGUAGE = 'i18nextLng',
  FEATURE_FLAGS = 'featureFlags',
}
